import { Component, Inject, Input, OnInit } from 'ng-metadata/core';
import { element } from 'angular';
import * as loaded from 'image-loaded';

import './media-type-icon.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentMediaTypeIcon
 * @module mw.components.contentDocuments
 *
 * @param {string} [media-type] - Supported values include 'news', 'facebook', 'instagram', 'twitter', 'youtube', 'social_blogs', 'social_reviews', 'social_message_boards', 'social_comments', 'tveyes_television', 'tveyes_radio'
 *
 * @description
 * `<mw-content-document-media-type-icon>` is a component that renders a specific icon for a media type
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-media-type-icon media-type="news"></mw-content-document-media-type-icon>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-media-type-icon',
    template: `
        <a href="https://twitter.com" target="_blank" ng-if="::$ctrl.mediaType === 'twitter'">
            <mw-icon class="mw-content-document-media-type-icon" svg-icon="{{::$ctrl.icon}}"></mw-icon>
        </a>
        <mw-icon class="mw-content-document-media-type-icon" ng-if="::$ctrl.mediaType !== 'twitter'" svg-icon="{{::$ctrl.icon}}"></mw-icon>
    `
})
export class MediaTypeIconComponent implements OnInit {
    @Input('<') mediaType: string;

    icon: string;

    constructor() {}

    ngOnInit() {
        const mediaTypeIcons = {
            news: 'meltwater:editorial',
            facebook: 'meltwater:facebook',
            instagram: 'meltwater:instagram',
            reddit: 'meltwater:reddit',
            twitter: 'meltwater:twitter',
            youtube: 'meltwater:youtube',
            social_blogs: 'meltwater:blogger',
            social_reviews: 'meltwater:product-review',
            social_message_boards: 'meltwater:forum',
            social_comments: 'meltwater:comment',
            tveyes_television: 'meltwater:tv',
            tveyes_radio: 'meltwater:radio',
            editorial_blogs: ''
        };

        this.icon = mediaTypeIcons[this.mediaType];
    }

}






// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/media-type-icon/media-type-icon.component.ts